var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 22,
    viewBox: "0 0 9 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00195312 4.02344C0.00195312 1.80664 1.78906 0 4.01562 0C6.24219 0 8.01953 1.80664 8.01953 4.02344C8.01953 5.84961 6.78906 7.40234 5.10938 7.88086V17.1484C5.10938 19.6484 4.42578 21.3281 4.01562 21.3281C3.5957 21.3281 2.90234 19.6387 2.90234 17.1484V7.88086C1.22266 7.39258 0.00195312 5.84961 0.00195312 4.02344ZM2.87305 4.24805C3.625 4.24805 4.24023 3.61328 4.24023 2.87109C4.24023 2.12891 3.625 1.50391 2.87305 1.50391C2.15039 1.50391 1.50586 2.12891 1.50586 2.87109C1.50586 3.61328 2.15039 4.24805 2.87305 4.24805Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.87e9bc4b141cff3e93e17e35c924b54a.svg";
export { ForwardRef as ReactComponent };